import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="newsletter-subscription"
export default class extends Controller {
  static targets = ['email']

  submit(e) {
    const email = this.emailTarget.value
    const userData = { email }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'newsletter_subscription_submitted',
      enhanced_conversion_data: userData
    })
  }
}
